import HelptapEditor from '../helpers';

export function determineBaseProperties(props) {

  const element = props.element;
  const properties = {
    ...props
  };

  if (HelptapEditor.dataCollection.isDatabaseConnectedNode(element) === true) {
    properties.enableAdvancedOptions = true;
    properties.contentEditable = false;
  }

  return properties;

}